import React from "react";
import "./ReactivityTags.scss";

import {Button} from "../../../../../components/Button";


const ReactivityTags = ({
            title = "",
            handleDeclined = ()=>{},
            handleConfirmed = ()=>{},
       }) => {

    return (
        <div id="tag-moderations-qualification-medias-tags">
            <div className={"category-title"}>{title}</div>
            <div className={"btn-group"}>
                <Button
                    className={`category-success`}
                    content={"Oui"}
                    onClick={()=>handleConfirmed()}
                />
                <Button
                    className={`category-error`}
                    content={"Non"}
                    onClick={()=>handleDeclined()}
                />
            </div>
        </div>
    )
}

export default ReactivityTags;